import React from "react";
import { Icon } from "@chakra-ui/react";

export function HeroGradient() {
  return (
    <Icon
      display={{ base: "none", md: "inline-block" }}
      pos="absolute"
      top={0}
      left={0}
      right={0}
      width="100%"
      height="auto"
      fill="none"
      viewBox="0 0 1440 826"
    >
      <mask
        id="hero-gradient-web-a"
        width="1440"
        height="826"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#fff" d="M0 0h1440v826H0z" />
      </mask>
      <g mask="url(#hero-gradient-web-a)">
        <g filter="url(#hero-gradient-web-b)">
          <ellipse
            cx="1135.81"
            cy="-244.057"
            fill="url(#hero-gradient-web-c)"
            fillOpacity=".8"
            rx="505.813"
            ry="476.943"
          />
        </g>
        <g filter="url(#hero-gradient-web-d)">
          <ellipse cx="382" cy="-412.529" fill="url(#hero-gradient-web-e)" rx="702" ry="595.456" />
        </g>
        <g filter="url(#hero-gradient-web-f)">
          <circle cx="1700.39" cy="141.755" r="700.466" fill="url(#hero-gradient-web-g)" />
        </g>
      </g>
      <defs>
        <radialGradient
          id="hero-gradient-web-c"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="scale(505.813 476.943) rotate(90 1.379 .867)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#57D7FF" />
          <stop offset="1" stopColor="#57D7FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="hero-gradient-web-e"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 595.456 -702 0 382 -412.529)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40E398" />
          <stop offset="1" stopColor="#40E398" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="hero-gradient-web-g"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(90 779.317 921.073) scale(700.466)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40E398" />
          <stop offset="1" stopColor="#40E398" stopOpacity="0" />
        </radialGradient>
        <filter
          id="hero-gradient-web-b"
          width="1199.63"
          height="1141.89"
          x="536"
          y="-815"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8665_1348" stdDeviation="47" />
        </filter>
        <filter
          id="hero-gradient-web-d"
          width="1804"
          height="1590.91"
          x="-520"
          y="-1207.98"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8665_1348" stdDeviation="100" />
        </filter>
        <filter
          id="hero-gradient-web-f"
          width="1612.46"
          height="1612.46"
          x="894.163"
          y="-664.474"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8665_1348" stdDeviation="52.882" />
        </filter>
      </defs>
    </Icon>
  );
}

export function HeroGradientMobile() {
  return (
    <Icon
      display={{ base: "inline-block", md: "none" }}
      pos="absolute"
      top={0}
      left={0}
      right={0}
      width="100%"
      height="auto"
      fill="none"
      viewBox="0 0 360 898"
    >
      <mask
        id="hero-gradient-mobile-a"
        width="360"
        height="898"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path fill="#fff" d="M0 0h360v898H0z" />
      </mask>
      <g mask="url(#hero-gradient-mobile-a)">
        <g filter="url(#hero-gradient-mobile-b)">
          <circle cx="499.5" cy="898.5" r="510.5" fill="url(#hero-gradient-mobile-c)" />
        </g>
        <g filter="url(#hero-gradient-mobile-d)">
          <circle cx="84" cy="-247" r="358" fill="url(#hero-gradient-mobile-e)" />
        </g>
        <g filter="url(#hero-gradient-mobile-f)">
          <ellipse cx="496.5" cy="-84" fill="url(#hero-gradient-mobile-g)" fillOpacity=".8" rx="253.5" ry="239" />
        </g>
      </g>
      <defs>
        <radialGradient
          id="hero-gradient-mobile-c"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="rotate(90 -199.5 699) scale(510.5)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40E398" />
          <stop offset="1" stopColor="#40E398" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="hero-gradient-mobile-e"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 358 -358 0 84 -247)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40E398" />
          <stop offset="1" stopColor="#40E398" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="hero-gradient-mobile-g"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 239 -253.5 0 496.5 -84)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#57D7FF" />
          <stop offset="1" stopColor="#57D7FF" stopOpacity="0" />
        </radialGradient>
        <filter
          id="hero-gradient-mobile-b"
          width="1421"
          height="1421"
          x="-211"
          y="188"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8671_2452" stdDeviation="100" />
        </filter>
        <filter
          id="hero-gradient-mobile-d"
          width="927.527"
          height="927.527"
          x="-379.763"
          y="-710.763"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8671_2452" stdDeviation="52.882" />
        </filter>
        <filter
          id="hero-gradient-mobile-f"
          width="695"
          height="666"
          x="149"
          y="-417"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur result="effect1_foregroundBlur_8671_2452" stdDeviation="47" />
        </filter>
      </defs>
    </Icon>
  );
}
